import {jsonMapMember, jsonMember, jsonObject} from "typedjson";
import {DxBaseControlOptions} from "./dx-base-control-options";

@jsonObject
export class DxComboboxControlOptions extends DxBaseControlOptions {
  /**
   * Возможные опции для комбика
   *  @controlId: string - ID контрола
   *  @label: string - подпись
   *  @hint: string - всплывающая подсказка
   *  @isDisabled: boolean - поле активно/не активно
   *  @isHidden: boolean - поле спрятано/отображается
   *
   *  @labelField: string - имя поля в массиве передаваемых элементов, корое будет использоваться для отображения данных в комбике
   *  @valueField: string - имя поля в массиве передаваемых элементов, корое будет использоваться в качестве id-шников
   *  @isSearchable: boolean - возможность поиска по элементам комбика
   *  @isMultiselect: boolean - возможность множественного выбора
   *  @hasLabels: boolean - мультиселект отображать метками или нет (только если isMultiselect: true)
   *
   * */

  /** имя поля в массиве передаваемых элементов, корое будет использоваться для отображения данных в комбике */
  @jsonMember({name: "labelField", constructor: String, emitDefaultValue: false, isRequired: true})
  private _labelField: string;

  /** имя поля в массиве передаваемых элементов, корое будет использоваться в качестве id-шников */
  @jsonMember({name: "valueField", constructor: String, emitDefaultValue: false, isRequired: true})
  private _valueField: string;

  /** возможность поиска по элементам комбика */
  @jsonMember({name: "isSearchable", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  private _isSearchable: boolean;

  /** возможность множественного выбора */
  @jsonMember({name: "isMultiselect", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  private _isMultiselect: boolean;

  /** мультиселект отображать метками или нет */
  @jsonMember({name: "hasLabels", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  private _hasLabels: boolean;

  /** говорит о том что комбик работает c серверной моделью данных и требудется предоставление реализации датасорса */
  @jsonMember({name: "useServerSideModel", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  private _useServerSideModel: boolean = false;

  /** дент датасорса, который используется в качестве поставщика данных при серверной модели */
  @jsonMember({name: "datasourceIdent", constructor: String, emitDefaultValue: false, isRequired: false})
  private _datasourceIdent: string;

  /** мапа с параметрами фильтрации датасорса */
  @jsonMapMember(String, Object, {name: 'filter', emitDefaultValue: false, isRequired: false})
  private _filter: Map<string, Object>;

  /** мапа с параметрами сортировки датасорса */
  @jsonMapMember(String, String, {name: 'sorts', emitDefaultValue: false, isRequired: false})
  private _sorts: Map<string, string>;


  get labelField(): string {
    return this._labelField;
  }

  set labelField(value: string) {
    this._labelField = value;
  }

  get valueField(): string {
    return this._valueField;
  }

  set valueField(value: string) {
    this._valueField = value;
  }

  get isSearchable(): boolean {
    return this._isSearchable;
  }

  set isSearchable(value: boolean) {
    this._isSearchable = value;
  }

  get isMultiselect(): boolean {
    return this._isMultiselect;
  }

  set isMultiselect(value: boolean) {
    this._isMultiselect = value;
  }

  get hasLabels(): boolean {
    return this._hasLabels;
  }

  set hasLabels(value: boolean) {
    this._hasLabels = value;
  }

  get useServerSideModel(): boolean {
    return this._useServerSideModel;
  }

  set useServerSideModel(value: boolean) {
    this._useServerSideModel = value;
  }

  get datasourceIdent(): string {
    return this._datasourceIdent;
  }

  set datasourceIdent(value: string) {
    this._datasourceIdent = value;
  }

  get filter(): Map<string, Object> {
    return this._filter;
  }

  set filter(value: Map<string, Object>) {
    this._filter = value;
  }

  get sorts(): Map<string, string> {
    return this._sorts;
  }

  set sorts(value: Map<string, string>) {
    this._sorts = value;
  }
}
